import React from 'react';

// The ledger's service glyphs.
//
// Inline SVG rather than lucide, because each is drawn INSIDE a token-tinted
// square at four different sizes and the pair (glyph, tint) has to stay welded
// together — `color` and `size` are the only props, and `Credits.shared.js`
// hands both from one `SERVICE_META` entry.
//
// A `.jsx` file and not part of `Credits.shared.js`, which is where they would
// naturally live: this repo's vitest cannot parse JSX inside a `.js` file
// (rollup's parser, no esbuild JSX loader configured), and the shared module is
// imported by tests. Splitting them keeps the shared file plain JS.

export function SparkIcon({ size = 16, color = 'currentColor' }) {
  return (
    <svg viewBox="0 0 24 24" fill={color} width={size} height={size} aria-hidden="true">
      <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z" />
    </svg>
  );
}

export function ShieldIcon({ size = 16, color = 'currentColor' }) {
  return (
    <svg viewBox="0 0 24 24" fill={color} width={size} height={size} aria-hidden="true">
      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 13l-3-3 1.41-1.41L11 11.17l4.59-4.58L17 8l-6 6z" />
    </svg>
  );
}

export function MicIcon({ size = 16, color = 'currentColor' }) {
  return (
    <svg viewBox="0 0 24 24" fill={color} width={size} height={size} aria-hidden="true">
      <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" />
    </svg>
  );
}

export function PlusIcon({ size = 16, color = 'currentColor' }) {
  return (
    <svg viewBox="0 0 24 24" fill={color} width={size} height={size} aria-hidden="true">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" />
    </svg>
  );
}

export function GiftIcon({ size = 16, color = 'currentColor' }) {
  return (
    <svg
      viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round"
      width={size} height={size} aria-hidden="true"
    >
      <path d="M20 12v8H4v-8" />
      <path d="M22 7H2v5h20z" />
      <path d="M12 7v13" />
      <path d="M12 7c-1.5 0-4-.6-4-3a2 2 0 0 1 4 0" />
      <path d="M12 7c1.5 0 4-.6 4-3a2 2 0 0 0-4 0" />
    </svg>
  );
}

export function ChatIcon({ size = 16, color = 'currentColor' }) {
  return (
    <svg viewBox="0 0 24 24" fill={color} width={size} height={size} aria-hidden="true">
      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
    </svg>
  );
}

export function CheckIcon({ size = 20 }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
    >
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}
